import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { TextDocument } from "../../dataService";
import { DocumentService } from "../../services/document.service";

export interface TermsModalResult {
  accepted: boolean;
  versionId: string;
  documentId: string;
  type: "terms" | "privacy";
}

@Component({
  selector: "app-terms-modal",
  templateUrl: "./terms-modal.component.html",
  styleUrls: ["./terms-modal.component.scss"],
})
export class TermsModalComponent {
  isScrolledToBottom = false;
  documentId: string;
  type: "terms" | "privacy";

  // Document properties
  document: TextDocument | null = null;
  isLoading = true;
  isError = false;

  constructor(
    public dialogRef: MatDialogRef<TermsModalComponent, TermsModalResult>,
    public toastr: ToastrService,
    private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      documentId: string;
      type: "terms" | "privacy";
    }
  ) {
    this.documentId = data.documentId;
    this.type = data.type;
    this.fetchDocument();
  }

  private fetchDocument(): void {
    this.documentService.getLatestDocumentVersion(this.documentId).subscribe({
      next: (result) => {
        this.document = result.document;
        this.isLoading = result.isLoading;
        this.isError = result.isError;
      },
      error: (error) => {
        console.error("Error fetching document:", error);
        this.isError = true;
        this.isLoading = false;
      },
    });
  }

  onScroll(event: any): void {
    const element = event.target;
    this.isScrolledToBottom =
      element.scrollHeight - element.scrollTop - 10 <= element.clientHeight; // 10 is the buffer
  }

  onCancel(): void {
    this.dialogRef.close({
      accepted: false,
      versionId: "",
      documentId: "",
      type: this.type,
    });
  }

  onAccept(): void {
    if (this.isError || this.isLoading) {
      return;
    }

    if (!this.isScrolledToBottom) {
      this.toastr.warning(
        "Terms not fully reviewed. Please scroll to the bottom of Terms to continue.",
        "Error"
      );
      return;
    }
    this.dialogRef.close({
      accepted: true,
      versionId: this.document.versions[0].id,
      documentId: this.documentId,
      type: this.type,
    });
  }
}
